import { Component, Input } from '@angular/core';
import { DropdownModule } from 'primeng/dropdown';
import { News } from '@/app/plateformebeneficiaire/core/models/news.model';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { NewsDetailsComponent } from '../news-details/news-details.component';

@Component({
  selector: 'app-news-card',
  templateUrl: './news-card.component.html',
  styleUrls: ['./news-card.component.scss'],
  standalone: true,
  imports: [
    DropdownModule,
    CommonModule,
    TooltipModule,
    DialogModule,
    NewsDetailsComponent,
  ],
})
export class NewsCardComponent {
  @Input() news!: News;
  @Input() showMotsCles = false;
  @Input() showMotCles = false;

  displayModal = false;

  openModal() {
    this.displayModal = true;
  }

  closeModal() {
    this.displayModal = false;
  }
}
